import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Stack
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useNotification} from "../../utils/hooks/useNotification";

interface BoatRegisterDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (value: number) => void;
    alreadyRegistered: boolean;
    defaultValue?: number | null;
}

const BoatRegisterDialog: React.FC<BoatRegisterDialogProps> = ({
                                                                   open,
                                                                   onClose,
                                                                   onSave,
                                                                   alreadyRegistered,
                                                                   defaultValue
                                                               }) => {
    const {showNotification} = useNotification();

    const [value, setValue] = useState<string>((alreadyRegistered && defaultValue) ? defaultValue.toString() : "");

    useEffect(() => {
        if (open) {
            setValue((alreadyRegistered && defaultValue) ? defaultValue.toString() : "");
        }
    }, [open, alreadyRegistered, defaultValue]);

    return (
        <Dialog open={open} onClose={() => {
            setValue("");
            onClose();
        }}
        >
            <DialogTitle> <strong>Registrace lodi do
                závodu</strong> - {alreadyRegistered ? "úprava" : "nastavení"} detailů</DialogTitle>
            <DialogContent>
                <Stack direction="row" spacing={2}>
                    <TextField
                        autoFocus
                        label="Startovní číslo"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    />
                    {(!alreadyRegistered && defaultValue) && (
                        <Button title="Použít trvalé startovní číslo lodi" size="small" variant="outlined"
                                sx={{minWidth: 140}}
                                onClick={() => setValue(defaultValue.toString())}>
                            Použít trvalé
                        </Button>
                    )}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    setValue("");
                    onClose();
                }}>
                    Zrušit
                </Button>
                <Button
                    onClick={() => {
                        if (!value) {
                            showNotification("Zadejte startovní číslo lodi", "error");
                            return;
                        }
                        const convertedValue = parseInt(value);
                        if (isNaN(convertedValue) || convertedValue < 1) {
                            showNotification("Zadejte platné startovní číslo lodi", "error");
                            return;
                        }
                        onSave(convertedValue);
                        setValue("");
                    }}
                    variant="contained"
                    color="success"
                >
                    {alreadyRegistered ? "Uložit" : "Registrovat"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BoatRegisterDialog;
